import { markChatPanelClosed, scheduleMobileHideRetries } from '../chat-session';
import { loadScriptOnce } from './load-script';
import type { ChatAdapter, ChatLoadContext } from './types';

function applyIdentify(username: string | null): void {
  if (!username || !window.Tawk_API?.setAttributes) return;
  window.Tawk_API.setAttributes({ name: username }, () => undefined);
}

function hideLauncher(): void {
  window.Tawk_API?.hideWidget?.();
}

function onReady(ctx: ChatLoadContext): void {
  if (ctx.isMobile) {
    hideLauncher();
  }
  applyIdentify(ctx.username);
}

export const tawkAdapter: ChatAdapter = {
  id: 'tawk',

  async load(ctx) {
    window.Tawk_API = window.Tawk_API || {};

    const api = window.Tawk_API;
    api.onLoad = () => {
      onReady(ctx);
    };
    api.onChatMessageAgent = () => {
      ctx.onUnread(1);
    };
    api.onChatMaximized = () => {
      ctx.onUnread(0);
    };
    api.onChatMinimized = () => {
      if (ctx.isMobile) markChatPanelClosed();
    };
    api.onChatHidden = () => {
      if (ctx.isMobile) markChatPanelClosed();
    };

    await loadScriptOnce({
      id: 'tawk-snippet',
      src: `https://embed.tawk.to/${ctx.key.replace(/^\/+/, '')}`,
      attrs: { crossorigin: '*' },
    });

    if (window.Tawk_API?.maximize || window.Tawk_API?.hideWidget) {
      onReady(ctx);
    }
    if (ctx.isMobile) {
      scheduleMobileHideRetries(hideLauncher);
    }
  },

  open() {
    const api = window.Tawk_API;
    if (!api) return;
    // After hideWidget(), maximize alone often no-ops — show first (Tawk docs).
    api.showWidget?.();
    api.maximize?.();
  },

  hideLauncher,

  identify(username) {
    applyIdentify(username);
  },
};
